import { Component, Input } from "@angular/core";
import { Controparte } from "../../models/controparte";
import { AltraParte } from "../../models/altraparte";

@Component({
  selector: 'app-associativa-soggetti-terzi',
  templateUrl: 'associativa-soggetti-terzi.component.html'
})

export class AssociativaSoggettiTerziComponent {
  @Input() altraParte: AltraParte;
}
